document.addEventListener("DOMContentLoaded", function () {
        function applyAccordionEffect() {
            function adjustTextPosition() {
            document.querySelectorAll(".custom-accordion-item").forEach((item) => {
                const textContainer = item.querySelector(".custom-accordion-text");
                const button = item.querySelector(".custom-accordion-button");
    
                if (textContainer) {
                    const textHeight = textContainer.offsetHeight;
                    const parentHeight = item.offsetHeight;
    
                    let newTop = (parentHeight / 2) - (textHeight / 2);
                    newTop = Math.max(20, newTop);
    
                    textContainer.style.top = `${newTop}px`;

                    if (button) {
                        button.style.bottom = "-30px";
                        button.style.left = "-30px";
                    }
                }
            });
        }
        let isMobile = window.innerWidth <= 768;
        const items = document.querySelectorAll(".custom-accordion-item");

        items.forEach((item) => {
            item.replaceWith(item.cloneNode(true));
        });

        const newItems = document.querySelectorAll(".custom-accordion-item");

        const firstItem = newItems[0];
        firstItem.classList.add("active");
        if (!isMobile) {
            firstItem.style.width = "80%";
        } else {
            firstItem.style.height = "300px";
        }

        newItems.forEach((item) => {
            const button = item.querySelector(".custom-accordion-button");
            if (!isMobile) {
                item.addEventListener("mouseenter", function () {
                    newItems.forEach((i) => {
                        i.classList.remove("active");
                        i.style.width = "10%";
                        i.style.zIndex = "1";

                        const hideButton = i.querySelector(".custom-accordion-button");
                        if (hideButton) hideButton.style.display = "none";
                    });

                    this.classList.add("active");
                    this.style.width = "80%";
                    this.style.zIndex = "2";

                    if (button) button.style.display = "inline-block";
                });
            } else {
                item.addEventListener("click", function () {

                    newItems.forEach((i) => {
                        i.classList.remove("active");
                        i.style.height = "100px";
                        i.style.zIndex = "1";

                        const hideButton = i.querySelector(".custom-accordion-button");
                        if (hideButton) hideButton.style.display = "none";
                    });

                    this.classList.add("active");
                    this.style.height = "300px";
                    this.style.zIndex = "2";

                    if (button) button.style.display = "inline-block";
                });
            }
        });
    }

    function updateAccordionDirection() {
        const container = document.querySelector(".custom-image-accordion");
        let isMobile = window.innerWidth <= 768;

        if (isMobile) {
            container.style.flexDirection = "column";
            document.querySelectorAll(".custom-accordion-item").forEach((item) => {
                item.style.width = "100%";
            });
        } else {
            container.style.flexDirection = "row";
            document.querySelectorAll(".custom-accordion-item").forEach((item) => {
                item.style.height = "100%";
                item.style.width = "10%";
            });
        }
    }

    window.addEventListener("resize", () => {
        updateAccordionDirection();
        applyAccordionEffect();
    });

    updateAccordionDirection();
    applyAccordionEffect();
});
